<mat-card>
  <app-card-header
    [title]="'Filtros de alarmas'"
    icono="filter_alt"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Búsqueda por texto libre -->
    <app-content-card title="Buscar por texto" icon="search">
      <section class="inputs-group" style="flex-direction: column">
        <mat-form-field>
          <mat-label>Dirección</mat-label>
          <input
            matInput
            type="text"
            placeholder="Ej: Av. Rivadavia 1234"
            [(ngModel)]="direccion"
            (ngModelChange)="onCambio()"
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Nombre</mat-label>
          <input
            matInput
            type="text"
            placeholder="Ej: Casa Pérez"
            [(ngModel)]="nombre"
            (ngModelChange)="onCambio()"
          />
        </mat-form-field>
      </section>
    </app-content-card>

    <!-- Pertenencia -->
    <app-content-card title="Pertenencia" icon="group_work">
      <section class="inputs-group" style="flex-direction: column">
        @if (zonas?.length) {
          <ng-select
            style="width: 100%"
            [items]="zonas"
            bindLabel="identificacion"
            bindValue="_id"
            placeholder="Zonas"
            notFoundText="Sin resultados"
            [multiple]="true"
            [closeOnSelect]="false"
            appendTo="body"
            [(ngModel)]="zonasSeleccionadas"
            (ngModelChange)="onCambio()"
          >
            <ng-template ng-option-tmp let-item="item">
              <span
                class="fam-color"
                [ngStyle]="{ 'background-color': item?.color || '#ffcc33' }"
              ></span>
              {{ item?.identificacion }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span
                class="ng-value-icon right irx-clickeable"
                role="button"
                tabindex="0"
                tooltip="Quitar"
                (click)="clear(item)"
                (keydown.enter)="clear(item)"
              >
                ×
              </span>
              <span
                class="fam-color"
                [ngStyle]="{ 'background-color': item?.color || '#ffcc33' }"
              ></span>
              {{ item?.identificacion }}
            </ng-template>
          </ng-select>
        }

        <app-cliente-selector
          [multiple]="true"
          placeholder="Clientes"
          [(ngModel)]="clientes"
          (ngModelChange)="onCambio()"
          (clientesChange)="clientesObjs = $event"
          [filterModules]="['moduloAlarmasDomiciliarias']"
          margin="0"
        ></app-cliente-selector>
      </section>
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="limpiar()">
      <mat-icon>filter_alt_off</mat-icon>
      Limpiar
    </button>
    <button irxBoton="principal" type="button" (click)="cerrar()">
      <mat-icon>check</mat-icon>
      Aplicar
    </button>
  </mat-card-actions>
</mat-card>
